import GothamNarrowBoldEOT from "./fonts/GothamNarrowBold.eot"
import GothamNarrowBoldOTF from "./fonts/GothamNarrowBold.otf"
import GothamNarrowBoldItalicEOT from "./fonts/GothamNarrowBoldItalic.eot"
import GothamNarrowBoldItalicOTF from "./fonts/GothamNarrowBoldItalic.otf"
import GothamBookEOT from "./fonts/GothamBook.eot"
import GothamBookOTF from "./fonts/GothamBook.otf"

import SolheimCupEOT from "./fonts/icons.eot";
import SolheimCupWOFF from "./fonts/icons.woff";
import SolheimCup9TTF from "./fonts/icons.ttf";
import SolheimCupSVG from "./fonts/icons.svg";

export default {
    GothamNarrowBoldEOT,
    GothamNarrowBoldOTF,
    GothamNarrowBoldItalicEOT,
    GothamNarrowBoldItalicOTF,
    GothamBookEOT,
    GothamBookOTF,
    SolheimCupEOT,
    SolheimCupWOFF,
    SolheimCup9TTF,
    SolheimCupSVG
};